module.exports = __webpack_public_path__ + "img/icon1.ed8c9a55.svg";